/**
 * Пагинация `.pager` (кит 2.12): «Показано N из M» обязательно, страницы
 * по 50. Номера страниц — как pageNumbers() в weos: первая, последняя,
 * соседи текущей и пропуски.
 */
export function pageNumbers(page: number, pages: number): (number | 'gap')[] {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const out: (number | 'gap')[] = [1];
  const from = Math.max(2, page - 1);
  const to = Math.min(pages - 1, page + 1);
  if (from > 2) out.push('gap');
  for (let p = from; p <= to; p++) out.push(p);
  if (to < pages - 1) out.push('gap');
  out.push(pages);
  return out;
}

export function Pagination({
  page,
  pageSize,
  total,
  shown,
  onPage,
}: {
  page: number;
  pageSize: number;
  total: number;
  /** Сколько строк на экране сейчас */
  shown: number;
  onPage: (page: number) => void;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="pager">
      <span className="shown">
        Показано <b>{shown}</b> из <b>{total}</b>
      </span>
      <span className={page > 1 ? 'pga' : 'pga off'} onClick={() => page > 1 && onPage(page - 1)}>
        <svg>
          <use href="#left" />
        </svg>
      </span>
      {pageNumbers(page, pages).map((p, i) =>
        p === 'gap' ? (
          <span key={`g${i}`} className="pgn gap">
            …
          </span>
        ) : (
          <span key={p} className={p === page ? 'pgn on' : 'pgn'} onClick={() => onPage(p)}>
            {p}
          </span>
        ),
      )}
      <span className={page < pages ? 'pga' : 'pga off'} onClick={() => page < pages && onPage(page + 1)}>
        <svg>
          <use href="#right" />
        </svg>
      </span>
    </div>
  );
}
